"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const emailVerificationStates_1 = require("@/common/components/EmailVerification/emailVerificationStates");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1({ signUpInputForm, }) {
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const isEmailVerified = (0, recoil_1.useRecoilValue)(emailVerificationStates_1.isEmailVerifiedState);
    const emailVerifyTimeLimit = (0, recoil_1.useRecoilValue)(emailVerificationStates_1.emailVerifyTimeLimitState);
    const isEmailVerifyRequired = isEmailVerified === false;
    const isEmailVerifyInProgress = isEmailVerified === 'proceeding' && emailVerifyTimeLimit !== 0;
    const { t } = (0, react_i18next_1.useTranslation)();
    const onSubmitSignUpSns = (inputData) => __awaiter(this, void 0, void 0, function* () {
        const { terms_of_use_agree, personal_info_agree, email, new_pwd, pwd_confirm, region, marketing_agree, } = inputData;
        if (isEmailVerifyRequired || isEmailVerifyInProgress) {
            alert(t('이메일 인증을 진행해주세요'));
        }
        else if (!detect_utils_1.passwordRegex.test(new_pwd || '')) {
            signUpInputForm.setError('new_pwd', { message: (0, string_utils_1.passwordErrorMessages)().requiredPattern });
        }
        else if (!terms_of_use_agree || !personal_info_agree) {
            (0, functions_1.showToastMessage)({ message: t('가입완료를 위해 동의를 진행해주세요') });
        }
        else if (!isSubmitting) {
            setIsSubmitting(true);
            const dataObj = {
                email,
                password: new_pwd,
                password_confirm: pwd_confirm,
                region,
                marketing_agree,
            };
            yield (0, api_1.postData)('/api/v1/sign-up', dataObj)
                .then(functions_1.goToMain)
                .catch(error => (0, _1.handleSignUpError)(error))
                .finally(() => setIsSubmitting(false));
        }
    });
    const maxWidth430 = (0, useMediaQuery_1.default)('(max-width:430px)');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            position: 'fixed',
            bottom: 0,
            width: '100%',
            maxWidth: maxWidth430 ? '430px' : '360px',
            padding: '16px',
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 0%, rgba(255, 255, 255, 0.6) 11.59%, #FFFFFF 30.42%)',
        } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: isSubmitting, variant: "orange_filled", fullWidth: true, onClick: signUpInputForm.handleSubmit(onSubmitSignUpSns) }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "info", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('가입 완료') })) })) })));
}
exports.default = default_1;
